// QBR eligiblity form

import React, { useState, useRef } from "react";
import InputFields from "../../common/input";
import ErrorComponent from "../UI/error";
import SuccessComponent from "../UI/success";
import { CheckBoxTick, CheckBoxBlank } from "../../common/icons";
import CardAsset from "../UI/card-asset";
import StepsIndicator from "../steps-indicator";
import NextButton from "../../components/UI/next-button";
import BackButton from "../UI/back-button";
import AllLoginNotification from "../../components/UI/all-login-notif-card";
import Cookies from "js-cookie";
import Layout from "../layout";
import ErrorBoundary from "../errors/ErrorBoundary";
import { useNavigate } from "react-router";

export default function QbrEligibilityStep({
  languages,
  currentStep,
  validateQbr,
  showCheckBoxTermsTermsError,
  QBRinput,
  isQBRError,
  QBRmessage,
  showQBRTerms,
  inputQBREligibilityEl,
  checkBoxTermsQBR,
  handleCheckBoxTermsQBR,
  checkBoxConsentQBR,
  handleCheckBoxConsentQBR,
  checkBoxContactInfoQBR,
  handleCheckBoxContactInfoQBR,
  inputQBRChange,
  goNextStep,
  stepNo,
  isProcessing,
  isDisabled,
  reviewLoading,
  QBRLoading,
  confirmValidateQBR,
  goPreviousStep,
  isQbr
}) {
  const navigate = useNavigate();
  const personalInfoEditLink =
    "https://secure.accor.com/account/index.en.shtml#/information/personal";
  const termsAndConditionsLink = languages.qbrTermsandConditionsLink
    ? languages.qbrTermsandConditionsLink
    : "https://www.accorplus.com/en-au/about/terms-and-conditions";
  const privacyPolicyLink = languages.qbrPrivacyPolicyLink
    ? languages.qbrPrivacyPolicyLink
    : "https://www.accorhotels.com/security-certificate/index.en.shtml";

  // if (currentStep !== stepNo) {
  //     return null
  // }
  return (
    <Layout>
      <ErrorBoundary>
        {/* Grid Layout for CardAsset and Form */}
        <div className="grid grid-cols-1 tablet:grid-cols-2 tablet:gap-4">
          {/* Left Column: CardAsset */}
          <div className="flex flex-col mx-auto xs:mx-0">
            <BackButton goPreviousStep={goPreviousStep} />
            <CardAsset />
          </div>

          {/* Right Column: Form */}
          <div className="xs:flex xs:justify-center xs:flex-col">
            <StepsIndicator
              step={1}
              stepText={
                languages && languages.qantasTitle
                  ? languages.qantasTitle
                  : "Eligibility"
              }
              subTitleHeader={
                languages && languages.qantasSubTitle
                  ? languages.qantasSubTitle
                  : "Qantas Eligibility Check"
              }
            />

            <div className="flex justify-evenly align-center tablet:mt-5">
              <form id="validate-qbr" className="w-full" onSubmit={validateQbr}>
                <InputFields
                  inputFields={QBRinput}
                  inputChange={inputQBRChange}
                  inputEl={inputQBREligibilityEl}
                />

                {isQBRError && QBRmessage && (
                  <ErrorComponent
                    errorMessage={QBRmessage}
                    languages={languages}
                  />
                )}

                {!isQBRError && QBRmessage && (
                  <SuccessComponent message={QBRmessage} />
                )}

                {showQBRTerms && (
                  <div>
                    {showCheckBoxTermsTermsError && (
                      <div class="mt-4">
                        <ErrorComponent
                          errorMessage={
                            "Please agree to the following terms and condition to proceed."
                          }
                          languages={languages}
                        />
                      </div>
                    )}
                    <div className=" d-block  mt-5 text-sm font-medium text-gray-900 dark:text-gray-300">
                      <strong>
                        {languages.qbrEligibilityJoin
                          ? languages.qbrEligibilityJoin
                          : "Before you join."}{" "}
                      </strong>{" "}
                      <br />
                      <span class="text-gray">
                        {languages.qbrEligibilityContact
                          ? languages.qbrEligibilityContact
                          : "We want to be able to contact you so you can activate your membership to enjoy your exclusive benefits as a member of Accor Plus."}
                      </span>
                    </div>
                    <div className="flex items-center mt-5">
                      <input
                        id="link-checkbox-consent"
                        type="checkbox"
                        checked={checkBoxConsentQBR}
                        onChange={handleCheckBoxConsentQBR}
                        className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        htmlFor="link-checkbox-consent"
                        className="link-checkbox flex items-center  text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        <span
                          className={`checkbox-icon ${checkBoxConsentQBR} mr-4`}
                        >
                          {checkBoxConsentQBR ? (
                            <CheckBoxTick />
                          ) : (
                            <CheckBoxBlank />
                          )}
                        </span>
                        <span className="text-gray">
                          {
                            "I consent to receive information about my membership and marketing offers from Accor Plus. You can choose to opt-out of receiving these communications or from any channel at any time once you have activated your membership account."
                          }{" "}
                          <br className="d-none" />
                        </span>
                      </label>
                    </div>
                    <div className=" d-block  mt-5">
                      <strong>
                        {languages.qbrEligibilityQantasTitle
                          ? languages.qbrEligibilityQantasTitle
                          : "Accor Plus & Qantas Business Rewards Terms of Service."}
                      </strong>{" "}
                    </div>

                    <div className="flex items-center mt-5">
                      <input
                        id="link-checkbox-terms"
                        type="checkbox"
                        checked={checkBoxTermsQBR}
                        onChange={handleCheckBoxTermsQBR}
                        className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        htmlFor="link-checkbox-terms"
                        className="link-checkbox flex items-center  text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        <span
                          className={`checkbox-icon ${checkBoxTermsQBR} mr-4`}
                        >
                          {checkBoxTermsQBR ? (
                            <CheckBoxTick />
                          ) : (
                            <CheckBoxBlank />
                          )}
                        </span>
                        <span className="text-gray">
                          {languages.qbrTermsTextAgree
                            ? languages.qbrTermsTextAgree
                            : "I agree to the "}
                          <a
                            href={
                              languages.qbrTermsQantasLink
                                ? languages.qbrTermsQantasLink
                                : "http://www.qantasbusinessrewards.com/terms"
                            }
                            target="_blank"
                          >
                            <span>
                              {" "}
                              {languages.qbrTermsTextQantas
                                ? languages.qbrTermsTextQantas
                                : "Qantas Business Rewards Terms and Conditions"}{" "}
                            </span>
                          </a>
                          <span>
                            {languages.qbrTermsTextAccept
                              ? languages.qbrTermsTextAccept
                              : "and accept the"}
                          </span>
                          <a href={termsAndConditionsLink} target="_blank">
                            <span>
                              {" "}
                              {languages.qbrTermsandConditions
                                ? languages.qbrTermsandConditions
                                : "Accor Plus Terms and Conditions"}{" "}
                            </span>
                          </a>
                          <span>
                            {languages.qbrTermsTextAnd
                              ? languages.qbrTermsTextAnd
                              : "and"}{" "}
                          </span>
                          <a href={privacyPolicyLink} target="_blank">
                            <span>
                              {" "}
                              {languages.qbrPrivacyPolicy
                                ? languages.qbrPrivacyPolicy
                                : "Privacy Policy."}{" "}
                            </span>
                          </a>
                        </span>
                      </label>
                    </div>

                    <div className="flex items-center mt-5">
                      <input
                        id="link-checkbox-contact"
                        type="checkbox"
                        checked={checkBoxContactInfoQBR}
                        onChange={handleCheckBoxContactInfoQBR}
                        className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      />
                      <label
                        htmlFor="link-checkbox-contact"
                        className="link-checkbox flex items-center  text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        <span
                          className={`checkbox-icon ${checkBoxContactInfoQBR} mr-4`}
                        >
                          {checkBoxContactInfoQBR ? (
                            <CheckBoxTick />
                          ) : (
                            <CheckBoxBlank />
                          )}
                        </span>
                        <span className="text-gray">
                          {languages.qbrEligibilityContactInformationConsent
                            ? languages.qbrEligibilityContactInformationConsent
                            : "I agree to my contact information being shared with Qantas Business Rewards for the purpose of joining the programme or linking my existing Qantas Business Rewards account to earn Qantas Points with Accor Plus."}
                        </span>
                      </label>
                    </div>
                  </div>
                )}
              </form>
            </div>
            <NextButton
              isProcessing={isProcessing}
              goNextStep={goNextStep}
              languages={languages}
              isDisabled={isDisabled}
              currentStep={currentStep}
              checkBoxTermsQBR={checkBoxTermsQBR}
              validateQbr={validateQbr}
              isQbr={isQbr}
              full={true}
              reviewLoading={reviewLoading} // [Step] - Review
              QBRLoading={QBRLoading}
              confirmValidateQBR={() => confirmValidateQBR(navigate)}
            />
          </div>
        </div>
      </ErrorBoundary>
    </Layout>
  );
}
